<template>
  <button
    class="rounded-full focus:outline-none circle-button"
    :class="{
      'border border-secondary': bordered,
      'bg-secondary-300 text-secondary-400 cursor-not-allowed': disabled,
    }"
    :disabled="disabled"
    @click.stop="$emit('click')"
  >
    <slot></slot>
    <div v-if="$slots.icon" class="flex items-center m-auto">
      <slot name="icon"></slot>
    </div>
  </button>
</template>

<script>
export default {
  name: "CircleButton",
  props: {
    bordered: Boolean,
    disabled: Boolean,
  },
};
</script>
<style lang="scss" scoped>
.circle-button {
  border: 0;
}
@import "@/styles/tailwind.scss";
</style>
